import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => {
      setPosts(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
      <div className="max-w-3xl mb-16">
        <div className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] mb-6">Blog</div>
        <h1 className="font-serif text-5xl md:text-6xl text-white leading-[1.05]">
          Noticias <em className="gold-text not-italic">fiscales</em> y consejos para tu empresa.
        </h1>
      </div>

      {loading ? (
        <div className="text-zinc-500">Cargando artículos…</div>
      ) : (
        <div className="grid md:grid-cols-3 gap-8" data-testid="blog-grid">
          {posts.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="group bg-[#121214] border border-white/5 rounded-2xl overflow-hidden hover:border-[#D4AF37]/40 transition-colors"
            >
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={p.cover_image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-[0.24em] text-[#D4AF37] mb-3">
                    {p.category}
                  </div>
                  <h2 className="font-serif text-xl text-white mb-3 leading-snug group-hover:text-[#D4AF37] transition-colors">
                    {p.title}
                  </h2>
                  <p className="text-zinc-400 text-sm leading-relaxed line-clamp-3">
                    {p.excerpt}
                  </p>
                  <div className="mt-5 text-sm text-[#D4AF37] flex items-center gap-2">
                    Leer artículo <ArrowRight className="w-4 h-4" />
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      )}
    </div>
  );
}
